import { render, staticRenderFns } from "./ProgressDotBar.vue?vue&type=template&id=0060cdcb&scoped=true&"
import script from "./ProgressDotBar.vue?vue&type=script&lang=js&"
export * from "./ProgressDotBar.vue?vue&type=script&lang=js&"
import style0 from "./ProgressDotBar.vue?vue&type=style&index=0&id=0060cdcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060cdcb",
  null
  
)

export default component.exports